// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

import React from 'react';
//import ReactDOM from "react-dom";
import IframeResizer from 'iframe-resizer-react';
import urlProps from "../resources/properties";
import './App.css';
import * as microsoftTeams from "@microsoft/teams-js";
import { Label, Segment } from "@fluentui/react-northstar";
import ChannelPicker from "./subcomponents/ChannelPicker";

/**
 * The 'PersonalTab' component renders the main tab content
 * of your app.
 */
class Abocard extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      context: {},
      iFrameLink: urlProps.properties.abocardLink.getFullUrl()
    }

    this.changeAboWidgetChannels = (e) => {
      console.log(e);
      urlProps.properties.abocardLink.setChannels(e.map((x) => x.name))
      this.setState({
        iFrameLink: urlProps.properties.abocardLink.getFullUrl()
      })
      console.log(urlProps.properties.abocardLink)
    };
  }

  //React lifecycle method that gets called once a component has finished mounting
  //Learn more: https://reactjs.org/docs/react-component.html#componentdidmount
  componentDidMount(){
    // Get the user context from Teams and set it in the state
    microsoftTeams.initialize(() => {

      microsoftTeams.getContext((context, error) => {
        this.setState({
          context: context
        });
      });
      // Next steps: Error handling using the error object
      console.log(urlProps.properties.groupcardLink.getUrl())

    })
  }

  render() {
    return (
      <div>
        <IframeResizer         
            style={{width: "805px",
              height: "533px"}}
            src={this.state.iFrameLink} 
            scrolling="no" 
            frameBorder="0"
            heightCalculationMethod="lowestElement"
            title="Abocard"
            autoResize="true"
        />
        <Segment>
          <Label>Channelauswahl für "Widget: Carousel Card"</Label>
          <ChannelPicker onItemChange={this.changeAboWidgetChannels} />
        </Segment>
      </div>
    );
}
}
export default Abocard;